module.exports = "https://cdn.realtymogul.com/static/media/HIW_steps_3.3c2e6d63.jpg";